import DPkr from 'react-datepicker';

export default class DatePicker extends DPkr {
  deferFocusInput = () => {
    this.cancelFocusInput();
  };
}
